import { createContext } from "react";

export interface EmailsTemplatesModalContextValue {
  emailTemplatesModalOpen: boolean;
  hideEmailTemplatesModal(): void;
  showEmailTemplatesModal(): void;
}

const EmailsTemplatesModalContext = createContext<EmailsTemplatesModalContextValue | null>(null);

EmailsTemplatesModalContext.displayName = "EmailsTemplatesModalContext";

export default EmailsTemplatesModalContext;
